// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"8385f5a4","358":"574c159d","540":"8bff1bfc","728":"228bd102","772":"f893d787","787":"e97d33e3"}[chunkId] + ".chunk.js";
};